"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[477],{

/***/ 3778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7320);

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
// eslint-disable react/jsx-no-target-blank
var ExternalLink = function(param) {
    var href = param.href, _isIOLink = param.isIOLink, isIOLink = _isIOLink === void 0 ? false : _isIOLink, _classNames = param.classNames, classNames = _classNames === void 0 ? 'text-primary-400 hover:text-primary-600 dark:hover:text-primary-300' : _classNames, children = param.children, props = param.props;
    return isIOLink ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("a", _objectSpread({
        className: classNames,
        target: "_self",
        rel: "prerender",
        href: href
    }, props, {
        children: children
    })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("a", _objectSpread({
        className: classNames,
        target: "_blank",
        rel: "noopener noreferrer",
        href: "".concat(href).concat(href.indexOf('?') < 0 ? '?' : '&', "from=iolivares.com")
    }, props, {
        children: children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ExternalLink);


/***/ }),

/***/ 5315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer; }
});

// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs
var jsx_runtime = __webpack_require__(7320);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(1720);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 28 modules
var esm = __webpack_require__(7985);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/listbox/listbox.esm.js + 9 modules
var listbox_esm = __webpack_require__(4501);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.esm.js + 4 modules
var transition_esm = __webpack_require__(6654);
// EXTERNAL MODULE: ./components/ExternalLink.js
var ExternalLink = __webpack_require__(3778);
// EXTERNAL MODULE: ./lib/supportedLangs.js
var supportedLangs = __webpack_require__(5445);
// EXTERNAL MODULE: ./data/metadata.json
var metadata = __webpack_require__(7700);
;// CONCATENATED MODULE: ./lib/email.js

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var email = 'moc.seraviloi@ih';
var ref = _slicedToArray(email.split('@'), 2);
var domain = ref[0], email_name = ref[1];
var sendEmail = function(e) {
    e.preventDefault();
    var link = e.currentTarget;
    var name1 = link.getAttribute('data-name').split('').reverse().join('');
    var domain1 = link.getAttribute('data-domain').split('').reverse().join('');
    var lang = link.getAttribute('data-lang') || supportedLangs/* defaultLang */.Fp;
    var subjects = {
        'es': 'Contacto desde la web iolivares.com',
        'en': 'Contact from the website iolivares.com'
    };
    window.location.href = "mailto:".concat(name1, "@").concat(domain1, "?subject=").concat(subjects[lang]);
};

;// CONCATENATED MODULE: ./components/Footer.js











function Footer(param1) {
    var slugPathsLang = param1.slugPathsLang;
    var ref2 = (0,router.useRouter)(), push = ref2.push, pathname = ref2.pathname, asPath = ref2.asPath, query = ref2.query, locale = ref2.locale;
    var ref1 = (0,compat_module.useState)(locale), selected1 = ref1[0], setSelected = ref1[1];
    var t = (0,esm/* useTranslation */.$G)('common').t;
    var setLanguage = function(newLang) {
        setSelected(newLang);
        if (!slugPathsLang) {
            return push({
                pathname: pathname,
                query: query
            }, asPath, {
                locale: newLang
            });
        } else {
            var ref;
            var newSlug = (ref = slugPathsLang.slugs[newLang]) === null || ref === void 0 ? void 0 : ref.toString();
            return push({
                pathname: newSlug,
                query: {
                    slug: newSlug
                }
            }, "/".concat(newSlug), {
                locale: newLang
            });
        }
    };
    return(/*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "flex flex-col w-full mx-auto max-w-5xl text-left pt-5 pb-6 px-5 xl:px-0",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("pre", {
                    className: "text-xs text-gray-800 dark:text-gray-100",
                    children: [
                        "> $ cd ~/io".concat(locale !== supportedLangs/* defaultLang */.Fp ? '/' + locale : '').concat(asPath),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                            className: "w-1 h-4 inline-block bg-primary-800 dark:bg-gray-400 ml-2 rounded-sm motion-safe:animate-ping motion-safe:duration-75",
                            children: " "
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("footer", {
                className: "bg-gray-200 dark:bg-gray-800 shadow-xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                        className: "flex flex-col flex-wrap justify-center p-5 md:flex-row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "inline-flex justify-center w-full mx-auto sm:ml-auto sm:mt-0",
                                children: metadata/* SOCIAL_NETWORKS.map */.H1.map(function(icon, iconIdx) {
                                    /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)(ExternalLink/* default */.Z, {
                                        href: icon.url,
                                        classNames: "mx-2 sm:mx-4 hover:opacity-75 motion-safe:transition motion-safe:duration-500 motion-safe:ease-in-out motion-safe:transform focus:outline-none focus-visible:shadow-outline focus-visible:ring-2 ring-offset-current ring-offset-3",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(next_image["default"], {
                                            src: "/static/images/icons/".concat(icon.name, ".png"),
                                            alt: icon.name,
                                            width: "22",
                                            height: "22",
                                            className: "dark:filter dark:brightness-0 dark:invert"
                                        })
                                    }, iconIdx);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "w-full lg:w-1/2 flex flex-col flex-wrap justify-center pt-5 md:flex-row",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                    className: "text-gray-800 dark:text-gray-100 w-full text-center text-xs md:text-ms",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                            children: [
                                                t('footer-email-me'),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("a", {
                                                    className: "ml-1 inline-block text-primary-400 hover:text-primary-300 tracking-wide font-bold email-protection",
                                                    "data-domain": domain,
                                                    "data-name": email_name,
                                                    "data-lang": locale,
                                                    href: "#",
                                                    onClick: sendEmail,
                                                    rel: "noopener",
                                                    children: email
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("p", {
                                            children: t('footer-socialmedia-me')
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                        className: "px-8 bg-gray-100 dark:bg-gray-900",
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: "w-full mx-auto max-w-5xl py-5 flex flex-col md:flex-row flex-wrap justify-center md:justify-between items-start md:items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                    className: "text-xs text-center md:text-left w-full md:w-auto text-gray-800 dark:text-gray-100",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                            children: [
                                                "\xa9 ".concat(t('full-name'), " 2006-").concat(new Date().getFullYear()),
                                                ".",
                                                " ",
                                                t('footer-copyright')
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                            children: [
                                                t('footer-creativecommons'),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ExternalLink/* default */.Z, {
                                                    href: "http://creativecommons.org/licenses/by-nc/4.0/deed.".concat(locale),
                                                    classNames: "inline-block text-primary-400 hover:text-primary-600 dark:hover:text-primary-300",
                                                    children: "CC BY-NC 4.0"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                                            children: [
                                                t('footer-doodle-credits'),
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ExternalLink/* default */.Z, {
                                                    href: "https://www.instagram.com/maetschl.cartoons/",
                                                    classNames: "inline-block text-primary-400 hover:text-primary-600 dark:hover:text-primary-300",
                                                    children: "Maetschl Cartoons."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                    className: "text-sm text-left text-gray-800 dark:text-gray-50 mt-3 md:mt-0 flex justify-center md:justify-end w-full md:w-auto",
                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                        className: "w-40 mt-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(listbox_esm/* Listbox */.R, {
                                            value: selected1,
                                            onChange: setLanguage,
                                            children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                                className: "relative mt-1",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(listbox_esm/* Listbox.Button */.R.Button, {
                                                        className: "relative w-full py-2 pl-3 pr-10 text-left bg-gray-50 dark:bg-gray-700 rounded-lg shadow-md cursor-default focus:outline-none focus-visible:ring-2 focus-visible:ring-opacity-75 focus-visible:ring-gray-700 dark:focus-visible:ring-gray-50 focus-visible:ring-offset-gray-700 dark:focus-visible:ring-offset-gray-300 sm:text-sm",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                                                className: "block truncate",
                                                                children: t("language-".concat(locale))
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                                                className: "absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none",
                                                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("svg", {
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    className: "h-5 w-5 text-gray-400 dark:text-gray-50",
                                                                    viewBox: "0 0 20 20",
                                                                    fill: "currentColor",
                                                                    "aria-hidden": "true",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                                                                        fillRule: "evenodd",
                                                                        d: "M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z",
                                                                        clipRule: "evenodd"
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(transition_esm/* Transition */.u, {
                                                        as: compat_module.Fragment,
                                                        leave: "transition ease-in duration-100",
                                                        leaveFrom: "opacity-100",
                                                        leaveTo: "opacity-0",
                                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(listbox_esm/* Listbox.Options */.R.Options, {
                                                            className: "absolute w-full py-1 mt-1 overflow-auto text-base bg-gray-50 dark:bg-gray-900 backdrop-blur backdrop-filter rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm",
                                                            children: supportedLangs/* Langs.map */.Tu.map(function(lang, langIdx) {
                                                                /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)(listbox_esm/* Listbox.Option */.R.Option, {
                                                                    className: function(param) {
                                                                        var active = param.active;
                                                                        return "".concat(active ? 'text-primary-500 bg-gray-100 dark:bg-gray-100' : 'text-gray-900 dark:text-gray-100', " cursor-default select-none relative py-2 pl-10 pr-4");
                                                                    },
                                                                    value: lang,
                                                                    children: function(param) {
                                                                        var selected = param.selected, active = param.active;
                                                                        /*#__PURE__*/ return (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                                                                    className: "".concat(selected ? 'font-medium' : 'font-normal', " block truncate"),
                                                                                    children: t("language-".concat(lang))
                                                                                }),
                                                                                selected ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                                                                                    className: "".concat(active ? 'text-primary-500' : 'text-gray-100', " absolute inset-y-0 left-0 flex items-center pl-3"),
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("svg", {
                                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                                        className: "h-6 w-6",
                                                                                        fill: "none",
                                                                                        viewBox: "0 0 24 24",
                                                                                        stroke: "currentColor",
                                                                                        "aria-hidden": "true",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                                                                                            strokeLinecap: "round",
                                                                                            strokeLinejoin: "round",
                                                                                            strokeWidth: 2,
                                                                                            d: "M5 13l4 4L19 7"
                                                                                        })
                                                                                    })
                                                                                }) : null
                                                                            ]
                                                                        });
                                                                    }
                                                                }, langIdx);
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: "container mx-auto p-5 text-xs text-center text-gray-800 dark:text-gray-100",
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("p", {
                    className: "inline-block",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                            children: t('footer-made-width')
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                            className: "ml-2 mr-3",
                            children: "❤️"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                            children: "&"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                            className: "ml-3 mr-2",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                className: "h-5 w-5 inline-block",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeWidth: 2,
                                    d: "M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                            children: t('footer-made-from')
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                            className: "ml-2 mr-3",
                            children: "🇨🇱"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("span", {
                            className: "mr-2",
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(next_link["default"], {
                                href: "/uses",
                                children: t('footer-made-with')
                            })
                        })
                    ]
                })
            })
        ]
    }));
};


/***/ }),

/***/ 7673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7320);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1720);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7985);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6010);
/* harmony import */ var _io_components_ExternalLink__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3778);







function Header() {
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)('common').t;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isMenuActive = ref[0], toggleMenu = ref[1];
    var escapeAction = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(event) {
        if (event.keyCode === 27) {
            toggleMenu(false);
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        document.addEventListener('keydown', escapeAction, false);
        return function() {
            document.removeEventListener('keydown', escapeAction, false);
        };
    }, [
        escapeAction
    ]);
    var getNavClassName = function(path) {
        var currentPath = router.pathname.replace('/', '');
        var linksClassNames = 'px-1 md:px-4 py-2 mr-1 font-medium ' + 'text-gray-600 dark:text-gray-100 hover:text-gray-900 dark:hover:text-gray-400 ' + 'motion-safe:transition-all motion-safe:transform ' + 'rounded-md focus:outline-none focus-visible:shadow-outline ' + 'focus-visible:ring-2 ring-offset-current ring-offset-2';
        return currentPath === path ? linksClassNames + ' nav-active' : linksClassNames;
    };
    var toggleNavigation = function() {
        toggleMenu(!isMenuActive);
        document.querySelector('#navigation .nav-list').focus();
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                className: "".concat(isMenuActive ? 'inline-block' : 'hidden', " h-[60px]")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("header", {
                id: "header",
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)('w-full mx-auto max-w-5xl text-gray-700 bg-transparent', 'motion-safe:transition motion-safe:duration-500 motion-safe:ease-in-out motion-safe:transform', {
                    'is-active': isMenuActive
                }),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("nav", {
                    id: "navigation",
                    className: "flex flex-wrap flex-row justify-between",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(next_link__WEBPACK_IMPORTED_MODULE_3__["default"], {
                            href: "/",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("a", {
                                className: "pl-5 xl:pl-0 pr-6 lg:pr-8 rounded-md z-30 focus-visible:shadow-outline focus-visible:ring-2 ring-offset-current ring-offset-4",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                                    className: "inline-flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                                            className: "w-1 h-1 lg:w-2 lg:h-2 p-2 mt-3 mr-1 rounded-full bg-gradient-to-tr from-gray-700 to-primary-400 dark:from-gray-50 dark:to-gray-400 motion-safe:hover:animate-ping motion-safe:hover:duration-75"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                                            className: "inline-flex items-center",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("h2", {
                                                className: "block py-2 pl-1 mr-1 text-3xl lg:text-4xl font-bold tracking-tighter cursor-pointer text-gray-800 hover:text-primary-700 dark:text-gray-50 dark:hover:text-gray-400 motion-safe:transition motion-safe:duration-500 motion-safe:ease-in-out motion-safe:transform",
                                                children: "com"
                                            })
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("ul", {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)('nav-list', {
                                'is-active': isMenuActive
                            }),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("li", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(next_link__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                        href: "/",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("a", {
                                            className: getNavClassName(''),
                                            children: t('nav-home')
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("li", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(next_link__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                        href: "/blog",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("a", {
                                            className: getNavClassName('blog'),
                                            children: t('nav-blog')
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("li", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(next_link__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                        href: "/talks",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("a", {
                                            className: getNavClassName('talks'),
                                            children: t('nav-talks')
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("li", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_io_components_ExternalLink__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        classNames: getNavClassName('photos'),
                                        href: "https://iolivares.photos",
                                        isIOLink: true,
                                        children: t('nav-photos')
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("li", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(next_link__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                        href: "/uses",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("a", {
                                            className: getNavClassName('uses'),
                                            children: t('nav-uses')
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("li", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(next_link__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                        href: "/about",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("a", {
                                            className: getNavClassName('about'),
                                            children: t('nav-about')
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("button", {
                            className: "hamburger hamburger--spin ".concat(isMenuActive ? 'is-active' : ''),
                            onClick: toggleNavigation,
                            type: "button",
                            "aria-label": t("nav-a11y-mobile-".concat(isMenuActive ? 'close' : 'open')),
                            "aria-controls": "navigation",
                            "aria-expanded": isMenuActive,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                                className: "hamburger-box",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("span", {
                                    className: "hamburger-inner"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    }));
};


/***/ }),

/***/ 8549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Meta; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7320);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9527);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7985);
/* harmony import */ var _io_data_metadata_json__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7700);
/* harmony import */ var _io_lib_supportedLangs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5445);






function Meta(props) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)('common').t;
    var title = props.title, summary = props.summary, publishedTime = props.publishedTime, type = props.type, image = props.image, image_alt = props.image_alt;
    var meta = {
        name: _io_data_metadata_json__WEBPACK_IMPORTED_MODULE_4__/* .NAME */ .A1,
        title: title || _io_data_metadata_json__WEBPACK_IMPORTED_MODULE_4__/* .DEFAULT_TITLE */ .i2,
        description: summary || _io_data_metadata_json__WEBPACK_IMPORTED_MODULE_4__/* .DESCRIPTION */ .dz,
        image: image || _io_data_metadata_json__WEBPACK_IMPORTED_MODULE_4__/* .OPENGRAPH.IMAGE */ .$p.k4,
        image_sm: _io_data_metadata_json__WEBPACK_IMPORTED_MODULE_4__/* .OPENGRAPH.IMAGE_SMALL */ .$p.T$,
        image_alt: image_alt || _io_data_metadata_json__WEBPACK_IMPORTED_MODULE_4__/* .OPENGRAPH.IMAGE_ALT */ .$p._m,
        tw_user: _io_data_metadata_json__WEBPACK_IMPORTED_MODULE_4__/* .OPENGRAPH.TWITTER_USER */ .$p.Ow,
        type: type || 'website',
        canonical: "".concat(_io_data_metadata_json__WEBPACK_IMPORTED_MODULE_4__/* .URL */ .Jx).concat(router.locale !== _io_lib_supportedLangs__WEBPACK_IMPORTED_MODULE_5__/* .defaultLang */ .Fp ? '/' + router.locale : '').concat(router.asPath)
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(next_head__WEBPACK_IMPORTED_MODULE_1__["default"], {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("title", {
                        children: meta.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("link", {
                        rel: "canonical",
                        href: meta.canonical
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                        name: "description",
                        content: meta.description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                        name: "robots",
                        content: "follow, index"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                        name: "googlebot",
                        content: "follow, index"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                        name: "author",
                        content: meta.name
                    }),
                    type === "article" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                        name: "article:author",
                        content: meta.name
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                        property: "og:url",
                        content: meta.canonical
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                        property: "og:type",
                        content: meta.type
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                        property: "og:site_name",
                        content: meta.name
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                        property: "og:description",
                        content: meta.description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                        property: "og:locale",
                        content: (0,_io_lib_supportedLangs__WEBPACK_IMPORTED_MODULE_5__/* .LangsToISO */ .rB)(router.locale)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                        property: "og:title",
                        content: meta.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                        property: "og:image",
                        content: meta.image
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                        property: "og:image:alt",
                        content: meta.image_alt
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                        property: "og:image:width",
                        content: "1600"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                        property: "og:image:height",
                        content: "882"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                        property: "og:image",
                        content: meta.image_sm
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                        property: "og:image:alt",
                        content: meta.image_alt
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                        property: "og:image:width",
                        content: "300"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                        property: "og:image:height",
                        content: "200"
                    }),
                    publishedTime && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                        property: "article:published_time",
                        content: publishedTime
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                        name: "twitter:site",
                        content: meta.tw_user
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                        name: "twitter:creator",
                        content: meta.tw_user
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                        name: "twitter:title",
                        content: meta.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                        name: "twitter:description",
                        content: meta.description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("meta", {
                        name: "twitter:image",
                        content: meta.image
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                className: "w-full max-w-5xl relative flex mx-auto",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("a", {
                    className: "skip-to-content",
                    href: "#main-content",
                    children: t('skip-content')
                })
            })
        ]
    }));
};


/***/ }),

/***/ 5445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tu": function() { return /* binding */ Langs; },
/* harmony export */   "rB": function() { return /* binding */ LangsToISO; },
/* harmony export */   "Fp": function() { return /* binding */ defaultLang; }
/* harmony export */ });
var Langs = [
    'en',
    'es', 
];
var LangsToISO = function(lang) {
    return ({
        'es': 'es-US',
        'en': 'en-US'
    })[lang];
};
var defaultLang = 'en';


/***/ }),

/***/ 7700:
/***/ (function(module) {

module.exports = JSON.parse('{"A1":"Iván Olivares Rojas","i2":"Building web experiences since 2006 | Iván Olivares Rojas","dz":"Tech Manager at Globant. Helping organizations to reinvent themselves. Sometimes I write about software industry and technology I love like Javascript.","Jx":"https://iolivares.com","$p":{"k4":"https://iolivares.com/static/images/opengraph1600x882.jpg","T$":"https://iolivares.com/static/images/opengraph300x200.jpg","_m":"Iván Olivares Rojas Website - Building web experiences since 2006","Ow":"@ivolivares"},"H1":[{"name":"github","url":"https://github.com/ivolivares"},{"name":"twitter","url":"https://twitter.com/intent/follow?screen_name=ivolivares"},{"name":"linkedin","url":"https://www.linkedin.com/in/ivanolivaresrojas"},{"name":"facebook","url":"https://www.facebook.com/iolivares.dev"},{"name":"instagram","url":"https://www.instagram.com/iolivares.photos"},{"name":"soundcloud","url":"https://soundcloud.com/djmaxis"},{"name":"spotify","url":"https://open.spotify.com/user/ivolivares"},{"name":"paypal","url":"https://www.paypal.me/ivanolivaresrojas/1"}]}');

/***/ })

}]);